<template>
    <div>

        <v-container grid-list-xl>

            <v-layout row wrap pt-5 pb-3 align-center>

                <v-flex xs12 sm2 text-xs-center @click="navigateToStep0('fr-be')" :style="{ cursor: 'pointer'}">

                    <img src="../assets/flags/belgium.png">

        </v-flex>

                    <v-flex d-flex xs12 sm3 text-xs-center text-sm-left @click="navigateToStep0('fr-be')" :style="{ cursor: 'pointer'}">

                        <div class="cs-countryTitle-text">

                            Belgique

                        </div>

                    </v-flex>

                    <v-flex xs2></v-flex>

                    <v-flex xs12 sm2 text-xs-center @click="navigateToStep0('nl-be')" :style="{ cursor: 'pointer'}">

                        <img src="../assets/flags/belgium.png"/>

        </v-flex>

                        <v-flex d-flex xs12 sm3 text-xs-center text-sm-left @click="navigateToStep0('nl-be')" :style="{ cursor: 'pointer'}">

                            <div class="cs-countryTitle-text">

                                België

                            </div>

                        </v-flex>

            </v-layout>

            <v-layout row wrap pt-5 pb-2 align-center>

                <v-flex xs12 sm2 text-xs-center @click="navigateToStep0('fr-fr')" :style="{ cursor: 'pointer'}">

                    <img src="../assets/flags/france.png"/>

        </v-flex>

                    <v-flex d-flex xs12 sm3 text-xs-center text-sm-left @click="navigateToStep0('fr-fr')" :style="{ cursor: 'pointer'}">

                        <div class="cs-countryTitle-text">

                            France

                        </div>

                    </v-flex>

                    <v-flex xs2></v-flex>

                    <v-flex xs12 sm2 text-xs-center @click="navigateToStep0('fr-lu')" :style="{ cursor: 'pointer'}">

                        <img src="../assets/flags/luxembourg.png"/>

        </v-flex>

                        <v-flex d-flex xs12 sm3 text-xs-center text-sm-left @click="navigateToStep1('fr-lu')" :style="{ cursor: 'pointer'}">

                            <div class="cs-countryTitle-text">

                                Luxembourg

                            </div>

                        </v-flex>

            </v-layout>

        </v-container>

    </div>
</template>

<script>
export default {
  name: 'home',

  data() {
    return {};
  },

  methods: {
    navigateToStep0(locale) {
      this.$router.push({ path: 'step0', query: { lng: locale } });
    }
  }
};
</script>

<style scoped>
.cs-countryTitle-text {
  font-family: 'Roboto', sans-serif;
  font-size: 39px;
  font-style: normal;
  font-weight: 300;
  color: rgb(117, 117, 117);
}

.cs-country-text {
  background-color: #ffffff;
  font-family: 'Raleway', sans-serif;
  font-size: 23px;
  font-weight: 900;
  line-height: 1.38;
  color: #424242;
}

.cs-color-ee {
  color: #5a91d3;
  font-size: 26px;
}

.cs-color-fi {
  color: #11367b;
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue